module.exports = __webpack_public_path__ + "static/img/6.ad1bb32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/eng/6.png
// module id = CALR
// module chunks = 0